import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { colors, IStyles, mediaCSS, palette } from '../../../../theme'

const catalogTemplateBroadcastsStyles: IStyles = {
    image: {
        ...grid.w30,
        position: 'relative',
    },
    deviceStatus: {
        position: 'absolute',
        top: 4,
        left: 4,
        zIndex: 2,
        ...grid.rowCenter,
    },
    deviceStatusIcon: {
        ...grid.rowCenter,
        width: 20,
        height: 20,
        borderRadius: 4,
        backgroundColor: colors.white,
        boxShadow: `0 1px 3px ${palette.black[100]}`,
    },
    wrapper: {
        ...grid.row,
        ...grid.mt_md,
        marginLeft: -grid.ml_md['margin-left'],
        marginBottom: -grid.mb_md['margin-bottom'],
        overflow: 'hidden',
    },
    mediaCellClassName: {
        [mediaCSS.tab]: {
            ...grid.col4,
        },
        [mediaCSS.tabMini]: {
            width: '50% !important',
        },
    },
    permissionsIconsWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
    },
    actionIconWrapper: {
        margin: '0 10px',
    },
}

addStyles(catalogTemplateBroadcastsStyles)
export default catalogTemplateBroadcastsStyles
